export const ADYEN_RECURRING_DETAIL_RECEIVED = 'ADYEN_RECURRING_DETAIL_RECEIVED';
export const ADYEN_RECURRING_DETAIL_RECEIVED_FAILED = 'ADYEN_RECURRING_DETAIL_RECEIVED_FAILED';
export const ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR = 'ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR';
export const ADYEN_HPP_FORM_DETAILS_FAILED = 'ADYEN_HPP_FORM_DETAILS_FAILED';
export const POLLING_ADYEN_FOR_DETAIL_CONFIRMATION = 'POLLING_ADYEN_FOR_DETAIL_CONFIRMATION';
export const POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED = 'POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED';
export const FETCH_ADYEN_RECURRING_DETAIL = 'FETCH_ADYEN_RECURRING_DETAIL';
export const FETCHING_PAYMENT_INFO = 'FETCHING_PAYMENT_INFO';
export const FETCHING_PAYMENT_INFO_STOPPED = 'FETCHING_PAYMENT_INFO_STOPPED';
export const PAYMENT_INFO_FETCHED = 'PAYMENT_INFO_FETCHED';
export const ALLOW_FETCH_RETRY = 'ALLOW_FETCH_RETRY';
export const DISALLOW_FETCH_RETRY = 'DISALLOW_FETCH_RETRY';

export function fetchRecurringDetail() {
  return {
    type: FETCH_ADYEN_RECURRING_DETAIL,
  };
}

export function fetchingPaymentInfo() {
  return {
    type: FETCHING_PAYMENT_INFO,
  };
}

export function fetchingPaymentInfoStopped() {
  return {
    type: FETCHING_PAYMENT_INFO_STOPPED,
  };
}

export function paymentInfoFetched() {
  return {
    type: PAYMENT_INFO_FETCHED,
  };
}

export function allowFetchRetry() {
  return {
    type: ALLOW_FETCH_RETRY,
  };
}

export function disallowFetchRetry() {
  return {
    type: DISALLOW_FETCH_RETRY,
  };
}

export function receivedRecurringDetail(recurringDetail) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED,
    payload: recurringDetail,
  };
}

export function receivedHPPFormDetailsFailed(err) {
  return {
    type: ADYEN_HPP_FORM_DETAILS_FAILED,
    err,
  };
}

export function receivedRecurringDetailFailed(err) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED_FAILED,
    err,
  };
}

export function receivedRecurringDetailFailedSystemError(err) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR,
    err,
  };
}

export function pollingForAdyenDetailConfirmation() {
  return {
    type: POLLING_ADYEN_FOR_DETAIL_CONFIRMATION,
  };
}

export function pollingForAdyenDetailConfirmationStopped() {
  return {
    type: POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED,
  };
}



// WEBPACK FOOTER //
// ./src/actions/payments.js